import React from "react";
import styled from 'styled-components';
import { Link } from "react-router-dom";

import { Button } from "./Button";

import products from '../data/products.json';

const StyledSecondaryHeader = styled.div`
    align-items: center;
    justify-content: flex-start;
    background: ${(props) => props.theme.colors.purple4};
    color: ${(props) => props.theme.colors.neutral10};
    display: flex;
	justify-content: space-between;
    height: 3rem;
    position: fixed;
    top: 3rem;
    transform: translateY(${(props) => props.isVisible ? '0' : '-3rem'});
    transition: all 0.15s ease-in;
    pointer-events: ${(props) => props.isVisible ? 'auto' : 'none'};
    width: 100%;
    z-index: 9;
`;

const LogoWordmark = styled(Link)`
    color: ${(props) => props.theme.colors.neutral10};
    flex: 1 0 auto;
    font-family: "Infiltrator";
    font-size: 2rem;
    line-height: 2rem;
    padding: 0.5rem 1rem;
    text-decoration: none;

    &:hover {
        background-color: ${(props) => props.theme.colors.purple3};
    }

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.second}) {
		flex: 0 0 auto;
	}
`;

const SecondaryHeaderButton = styled(Button)`
	background-color: ${(props) => props.theme.colors.neutral10};
	color: ${(props) => props.theme.colors.purple4};
	padding: 0.5rem 0.75rem;
	margin-right: 0.5rem;

    &:hover {
        background-color: ${(props) => props.theme.colors.neutral10};
        color: ${(props) => props.theme.colors.purple4};
    }
`;

export class BengalSecondaryHeader extends React.Component {
	render() {
		const { isVisible = false } = this.props;
		const data = products.find((product) => product.id === "bengal");

		return (
			<StyledSecondaryHeader isVisible={isVisible}>
				<LogoWordmark to="/">bengal</LogoWordmark>
				<SecondaryHeaderButton to={data.buyLink} label="Buy a Bengal" />
			</StyledSecondaryHeader>
		);
	}
}